import * as React from "react";

export const MethylationMethionineKeyContent = () => (
  <>
    <g id="Key">
      <rect width={1024} height={216} fill="white" />
      <g id="Container_2">
        <g id="key-item - Gene">
          <rect x={40.5} y={66.5} width={318} height={149} stroke="#818181" />
          <text
            id="gene-label"
            fill="#1A1A1A"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Bold"
            fontSize={12}
            letterSpacing="2.8px"
          >
            <tspan x={52.4383} y={86.4}>
              GENETICS
            </tspan>
          </text>
          <g id="Container_3">
            <g id="Container_4">
              <g id="Container_5">
                <g id="Component 2">
                  <g id="gene-lozenge">
                    <path
                      d="M56 96.3896H72C73.9941 96.3896 75.6104 98.0059 75.6104 100V116C75.6104 117.994 73.9941 119.61 72 119.61H56C54.0059 119.61 52.3896 117.994 52.3896 116V100C52.3896 98.0059 54.0059 96.3896 56 96.3896Z"
                      fill="#E5E5E5"
                    />
                    <path
                      d="M56 96.3896H72C73.9941 96.3896 75.6104 98.0059 75.6104 100V116C75.6104 117.994 73.9941 119.61 72 119.61H56C54.0059 119.61 52.3896 117.994 52.3896 116V100C52.3896 98.0059 54.0059 96.3896 56 96.3896Z"
                      stroke="#1A1A1A"
                      strokeWidth={0.778643}
                    />
                  </g>
                </g>
                <text
                  id="Description"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.0723} y={112.767}>
                    Not included in panel
                  </tspan>
                </text>
              </g>
              <g id="Container_6">
                <g id="Component 2_2">
                  <g id="gene-lozenge_2">
                    <path
                      d="M52 128C52 125.791 53.7909 124 56 124H72C74.2091 124 76 125.791 76 128V144C76 146.209 74.2091 148 72 148H56C53.7909 148 52 146.209 52 144V128Z"
                      fill="#CCBAFF"
                    />
                  </g>
                </g>
                <text
                  id="Description_2"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.2559} y={140.767}>
                    No read
                  </tspan>
                </text>
              </g>
              <g id="Container_7">
                <g id="Component 2_3">
                  <g id="snp-indicator">
                    <path
                      id="Polygon 3"
                      d="M63.3387 158.372C63.6326 157.876 64.3674 157.876 64.6613 158.372L70.8966 168.885C71.1905 169.381 70.8231 170 70.2352 170H57.7648C57.1769 170 56.8095 169.381 57.1034 168.885L63.3387 158.372Z"
                      fill="#1A1A1A"
                    />
                  </g>
                </g>
                <text
                  id="Description_3"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.1738} y={168.767}>
                    Increased activity
                  </tspan>
                </text>
              </g>
              <g id="Container_8">
                <g id="Component 2_4">
                  <g id="snp-indicator_2">
                    <path
                      id="Polygon 3_2"
                      d="M64.6613 197.628C64.3674 198.124 63.6326 198.124 63.3387 197.628L57.1034 187.115C56.8095 186.619 57.1769 186 57.7648 186L70.2352 186C70.8231 186 71.1905 186.619 70.8966 187.115L64.6613 197.628Z"
                      fill="#1A1A1A"
                    />
                  </g>
                </g>
                <text
                  id="Description_4"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.2285} y={196.767}>
                    Decreased activity
                  </tspan>
                </text>
              </g>
            </g>
            <g id="Container_9">
              <g id="Container_10">
                <g id="Component 2_5">
                  <g id="gene-lozenge_3">
                    <path
                      d="M237 100C237 97.7909 238.791 96 241 96H257C259.209 96 261 97.7909 261 100V116C261 118.209 259.209 120 257 120H241C238.791 120 237 118.209 237 116V100Z"
                      fill="#00BF86"
                    />
                  </g>
                </g>
                <text
                  id="Risk description"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.288} y={112.767}>
                    0 risk alleles
                  </tspan>
                </text>
              </g>
              <g id="Container_11">
                <g id="Component 2_6">
                  <g id="gene-lozenge_4">
                    <path
                      d="M237 128C237 125.791 238.791 124 241 124H257C259.209 124 261 125.791 261 128V144C261 146.209 259.209 148 257 148H241C238.791 148 237 146.209 237 144V128Z"
                      fill="#FF905F"
                    />
                  </g>
                </g>
                <text
                  id="Risk description_2"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.271} y={140.767}>
                    1 risk allele
                  </tspan>
                </text>
              </g>
              <g id="Container_12">
                <g id="Component 2_7">
                  <g id="gene-lozenge_5">
                    <path
                      d="M237 156C237 153.791 238.791 152 241 152H257C259.209 152 261 153.791 261 156V172C261 174.209 259.209 176 257 176H241C238.791 176 237 174.209 237 172V156Z"
                      fill="#FF5D6D"
                    />
                  </g>
                </g>
                <text
                  id="Risk description_3"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.006} y={168.767}>
                    2 risk alleles
                  </tspan>
                </text>
              </g>
            </g>
          </g>
        </g>
        <g id="Container_13">
          <g id="key-item - vitamin">
            <g id="Vitamin-Mineral">
              <g id="diamond">
                <path
                  id="Vector"
                  d="M412.378 66.9375L436.378 90.9375L412.378 114.938L388.378 90.9375L412.378 66.9375Z"
                  stroke="#1A1A1A"
                />
              </g>
            </g>
            <text
              id="Vitamin description"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={448.47} y={95.767}>
                Vitamin / Mineral
              </tspan>
            </text>
          </g>
          <g id="key-item - co factor">
            <g id="Cofactor">
              <g id="diamond_2">
                <g id="Vector_2">
                  <mask id="path-22-inside-1_18291_211484" fill="white">
                    <path d="M607 70L628 80.1818V101.818L607 112L586 101.818V80.1818L607 70Z" />
                  </mask>
                  <path
                    d="M607 70L628 80.1818V101.818L607 112L586 101.818V80.1818L607 70Z"
                    stroke="#1A1A1A"
                    strokeWidth={2}
                    mask="url(#path-22-inside-1_18291_211484)"
                  />
                </g>
              </g>
            </g>
            <text
              id="Cofactor_2"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={638.001} y={95.767}>
                Cofactor
              </tspan>
            </text>
          </g>
          <g id="key-item - Recycle">
            <g id="report-recycle-symbol">
              <g id="Vector_3">
                <mask id="path-24-inside-2_18291_211484" fill="white">
                  <path d="M739.883 107.875C739.883 108.807 739.127 109.563 738.195 109.563H728.068C724.171 109.561 721.738 105.342 723.686 101.968L730.92 89.4671L727.956 90.2583C726.697 90.5944 725.547 89.442 725.885 88.1838C726.042 87.5999 726.499 87.1441 727.083 86.988L733.997 85.1377C734.897 84.8962 735.823 85.431 736.064 86.3319L737.919 93.2457C738.165 94.1512 737.626 95.0838 736.718 95.3218C736.575 95.3591 736.428 95.3783 736.279 95.3788C735.516 95.3781 734.848 94.865 734.651 94.1276L733.849 91.1423L726.614 103.656C725.966 104.778 726.772 106.181 728.068 106.187H738.195C739.127 106.187 739.883 106.943 739.883 107.875ZM769.574 101.968L764.692 93.5285C763.995 92.432 762.373 92.5012 761.772 93.6531C761.516 94.1429 761.516 94.7268 761.772 95.2163L766.654 103.656C767.302 104.778 766.497 106.181 765.201 106.187H750.708L752.89 104.006C753.809 103.087 753.39 101.518 752.135 101.181C751.552 101.025 750.93 101.191 750.504 101.618L745.44 106.681C744.78 107.34 744.78 108.41 745.44 109.069L750.504 114.133C751.423 115.051 752.992 114.63 753.328 113.375C753.483 112.792 753.317 112.171 752.89 111.745L750.708 109.563H765.201C769.097 109.561 771.531 105.342 769.583 101.968H769.574ZM746.634 70.7424C747.239 70.7364 747.798 71.0598 748.094 71.5864L755.329 84.087L752.358 83.2895C751.093 82.9926 749.981 84.1764 750.357 85.4203C750.52 85.9623 750.945 86.3863 751.487 86.5492L758.403 88.4037C758.546 88.4412 758.692 88.4603 758.84 88.4607C759.603 88.46 760.271 87.947 760.468 87.2096L762.323 80.2915C762.69 79.0452 761.571 77.8686 760.308 78.1736C759.692 78.3222 759.212 78.8027 759.063 79.418L758.262 82.4076L751.016 69.8985C749.066 66.5299 744.203 66.5299 742.252 69.8985L737.366 78.3378C736.746 79.4796 737.594 80.8645 738.893 80.8305C739.465 80.8156 739.989 80.5127 740.288 80.0256L745.174 71.5864C745.471 71.0598 746.03 70.7364 746.634 70.7424Z" />
                </mask>
                <path
                  d="M739.883 107.875C739.883 108.807 739.127 109.563 738.195 109.563H728.068C724.171 109.561 721.738 105.342 723.686 101.968L730.92 89.4671L727.956 90.2583C726.697 90.5944 725.547 89.442 725.885 88.1838C726.042 87.5999 726.499 87.1441 727.083 86.988L733.997 85.1377C734.897 84.8962 735.823 85.431 736.064 86.3319L737.919 93.2457C738.165 94.1512 737.626 95.0838 736.718 95.3218C736.575 95.3591 736.428 95.3783 736.279 95.3788C735.516 95.3781 734.848 94.865 734.651 94.1276L733.849 91.1423L726.614 103.656C725.966 104.778 726.772 106.181 728.068 106.187H738.195C739.127 106.187 739.883 106.943 739.883 107.875ZM769.574 101.968L764.692 93.5285C763.995 92.432 762.373 92.5012 761.772 93.6531C761.516 94.1429 761.516 94.7268 761.772 95.2163L766.654 103.656C767.302 104.778 766.497 106.181 765.201 106.187H750.708L752.89 104.006C753.809 103.087 753.39 101.518 752.135 101.181C751.552 101.025 750.93 101.191 750.504 101.618L745.44 106.681C744.78 107.34 744.78 108.41 745.44 109.069L750.504 114.133C751.423 115.051 752.992 114.63 753.328 113.375C753.483 112.792 753.317 112.171 752.89 111.745L750.708 109.563H765.201C769.097 109.561 771.531 105.342 769.583 101.968H769.574ZM746.634 70.7424C747.239 70.7364 747.798 71.0598 748.094 71.5864L755.329 84.087L752.358 83.2895C751.093 82.9926 749.981 84.1764 750.357 85.4203C750.52 85.9623 750.945 86.3863 751.487 86.5492L758.403 88.4037C758.546 88.4412 758.692 88.4603 758.84 88.4607C759.603 88.46 760.271 87.947 760.468 87.2096L762.323 80.2915C762.69 79.0452 761.571 77.8686 760.308 78.1736C759.692 78.3222 759.212 78.8027 759.063 79.418L758.262 82.4076L751.016 69.8985C749.066 66.5299 744.203 66.5299 742.252 69.8985L737.366 78.3378C736.746 79.4796 737.594 80.8645 738.893 80.8305C739.465 80.8156 739.989 80.5127 740.288 80.0256L745.174 71.5864C745.471 71.0598 746.03 70.7364 746.634 70.7424Z"
                  stroke="#282828"
                  strokeWidth={2}
                  mask="url(#path-24-inside-2_18291_211484)"
                />
              </g>
            </g>
            <text
              id="Recycle"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={780.358} y={95.767}>
                Recycle
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </g>
  </>
);

const SvgMethylationMethionineKey = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={216}
    viewBox="0 0 1024 216"
    fill="none"
    {...props}
  >
    <MethylationMethionineKeyContent />
  </svg>
);

export default SvgMethylationMethionineKey;
